import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/setting/target/save',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `/setting/target/delete/${id}`,
    method: 'delete'
  })